<template>
  <div
    class="toast"
    :class="`toast--${type}`"
    role="alert"
    @click="dismiss"
    @mouseenter="pause"
    @mouseleave="resume"
  >
    <span class="toast__icon" :class="`toast__icon--${type}`">
      <v-icon size="12" color="white">{{ iconName }}</v-icon>
    </span>
    <span class="toast__body">{{ message }}</span>
    <button
      type="button"
      class="toast__close"
      aria-label="Close"
      @click.stop="dismiss"
    >
      <v-icon size="16">mdi-close</v-icon>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import type { ToastType } from '@modules/shared/stores/toast'

const props = defineProps<{
  id: number
  type: ToastType
  message: string
  duration: number
}>()

const emit = defineEmits<{ (e: 'dismiss', id: number): void }>()

const remaining = ref(props.duration)
const startedAt = ref(0)
const timer = ref<number | null>(null)

const iconName = computed(() => (props.type === 'success' ? 'mdi-check' : 'mdi-close'))

const dismiss = () => emit('dismiss', props.id)

const start = () => {
  if (remaining.value <= 0) return
  startedAt.value = Date.now()
  timer.value = window.setTimeout(dismiss, remaining.value)
}

const pause = () => {
  if (timer.value !== null) {
    clearTimeout(timer.value)
    timer.value = null
    remaining.value -= Date.now() - startedAt.value
  }
}

const resume = () => {
  if (timer.value === null) start()
}

onMounted(start)
onBeforeUnmount(() => {
  if (timer.value !== null) clearTimeout(timer.value)
})
</script>
